/* eslint-disable lines-between-class-members */
class CustomError extends Error {
  template?: string;
  properties?: any;
  constructor(params: any) {
    super(params);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError);
    }
  }
}

export default CustomError;
